import DocumentArrowFill from './DocumentArrowFill';

export default DocumentArrowFill;
